<div class="city-item--content"  [ngStyle]="{'background-image': 'url(' + data.background + ')'}">
    <div class="city-item--title"><h3>{{data.city}}</h3></div>
  </div>